export type PageViewNumberGeneratorFunction = (cookieName: string) => number;

export function createPageViewNumberGenerator(
  cookiesManager: CookiesManager,
): PageViewNumberGeneratorFunction {
  return (cookieName: string) => {
    const cookieValue = cookiesManager.get(cookieName);
    if (!cookieValue) {
      return 1;
    }

    const currentNumber = parseInt(cookieValue);
    if (Number.isNaN(currentNumber)) {
      return 1;
    }

    return currentNumber + 1;
  };
}
